<script setup lang="ts">
import { CmsDepth } from '@pkg/config/misc/cmsDepth';

const props = withDefaults(
  defineProps<{
    /**
     * When true (www), the back panel is fixed for the parallax reveal.
     * When false (business / simple), back content flows in document order.
     */
    parallax?: boolean;
  }>(),
  {
    parallax: true,
  },
);
</script>

<template>
  <footer
    class="c-footer min-h-[64px] bg-primary"
    :class="{ 'c-footer--parallax': props.parallax, 'c-footer--flat': !props.parallax }"
    :data-cms-depth="CmsDepth.Footer"
  >
    <div class="c-footer__main wrapper bg-primary-30 max-w-full desk:px-32">
      <slot name="main" />
    </div>
    <div class="c-footer__back bg-primary text-neutral-30 py-32 text-body--xsmall wrapper max-w-full desk:px-32">
      <slot name="back" />
    </div>
  </footer>
</template>

<style scoped>
.c-footer--parallax {
  --footer-parallax-height: 500px;

  padding-bottom: var(--footer-parallax-height);
  position: relative;
  z-index: theme('zIndex.footerFront');

  @screen tablet {
    --footer-parallax-height: 530px;
  }

  @screen tablet-wide {
    --footer-parallax-height: 590px;
  }

  @screen desk {
    --footer-parallax-height: 370px;
  }

  @screen big-desk {
    --footer-parallax-height: 400px;
  }
}

.c-footer--parallax .c-footer__main {
  position: relative;
  z-index: theme('zIndex.footerFront');
  max-width: 100%;
  padding: theme('spacing.0') theme('spacing.32');
}

.c-footer--parallax .c-footer__back {
  bottom: 0;
  position: fixed;
  z-index: theme('zIndex.footerBack');
  max-width: 100%;
  padding: theme('spacing.32');
}

.c-footer--flat {
  position: relative;
  z-index: theme('zIndex.footerFront');
}

.c-footer--flat .c-footer__main,
.c-footer--flat .c-footer__back {
  max-width: 100%;
  padding-left: theme('spacing.32');
  padding-right: theme('spacing.32');
}
</style>
